// extracted by mini-css-extract-plugin
module.exports = {"container":"Loading_container__jDzwe","container--opaque":"Loading_container--opaque__MAJYe","icon":"Loading_icon__xHPKz"};